import type { ApiResponse } from "@/types/apiResponse";
import type { Company } from "../types"
import { apiClient } from "../../../lib/apiClient";

const fetchCompany = async (): Promise<ApiResponse<Company>> => {
	return apiClient<ApiResponse>('/v1/empresa', {
		method: "GET"
	});
};

export default fetchCompany;
